export enum JumplinkActions {
  Add = 'ADD_JUMPLINK',
  Clear = 'DELETE_JUMPLINKS',
}

export interface JumplinkType {
  label?: string;
  href?: string;
}

export type JumplinkPayloadType = {
  [JumplinkActions.Add]: JumplinkType;
  [JumplinkActions.Clear]: null;
};
